<template>
    <div>
        <o-table ref="tableList" :enable-view="false" default-sort-by="id" default-sort-by-direction="desc" :title="$t('sandoz.chargebacks')"
                 :url="'/api/chargebacks?include=user,wholesaler_one'">
            <template slot="filter">
                <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                    <o-filter-select :items="userList" :title="$t('sandoz.requestor')" column="user_id" value-field="id" text-field="name"></o-filter-select>
                    <o-filter-select :items="conditionCategories" :title="$t('sandoz.condition_category')" column="condition_category" value-field="id" text-field="name"></o-filter-select>
                    <o-filter-text :title="$t('sandoz.chargeback_no')" column="id"></o-filter-text>
                </o-filter>
            </template>
            <template slot="head">
                <o-table-header column="id" :sortable="true">{{ $t('sandoz.chargeback_no') }}</o-table-header>
                <o-table-header column="chargeback_date" :sortable="true">{{ $t('sandoz.request_date') }}</o-table-header>
                <o-table-header :sortable="false">{{ $t('sandoz.wholesaler') }}</o-table-header>
                <o-table-header column="user.name" :sortable="false">{{ $t('sandoz.requestor') }}</o-table-header>
            </template>
            <template slot="body" slot-scope="props">
                <td>{{props.item.id}}</td>
                <td>{{props.item.chargeback_date | formatDate}}</td>
                <td>{{props.item.wholesaler_one ? props.item.wholesaler_one.data.wholesaler : ''}}</td>
                <td>{{props.item.user ? props.item.user.data.name : ''}}</td>
            </template>
            <template slot="body-controls" slot-scope="props">
              <td class="text-right">
                <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
                  <b-btn @click="cloneChargeback(props.item.id)" class="btn btn-secondary">
                    <fa icon="clone"/>
                  </b-btn>
                  <o-delete method="delete" v-if="!!user.is_super_user" :url="'/api/chargebacks/' + props.item.id" v-on:action-executed="$refs.tableList.search"></o-delete>
                  <router-link :to="{ path: $route.path + '/' + props.item.id }" class="btn btn-primary">
                    <fa icon="pencil-alt"/>
                  </router-link>
                </div>
              </td>
            </template>
        </o-table>
    </div>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'

export default {
  data: () => ({
    userList: [],
    statuses: [],
    showHide: [],
    kukoTypes: [],
    accountCategories: [],
    conditionCategories: []
  }),
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },
  created() {

    this.conditionCategories.push({id: 'otcProducts', name: this.$i18n.t('sandoz.products')})
    this.conditionCategories.push({id: 'materialGroup', name: this.$i18n.t('sandoz.material_group')})
    this.conditionCategories.push({id: 'portfolioRebate', name: this.$i18n.t('sandoz.portfolio_rebate')})
  },
  mounted() {
    axios.get('/api/system/users?filter%5Bactive%5D=1%25&sortBy=name&per_page=99999').then((response) => {
      this.userList = response.data.data
    }).catch((error) => {
      console.error(error)
    })
  },
  methods: {
    cloneChargeback(chargebackId) {
      let url = `/api/chargebacks/${chargebackId}?include=user,condition_product_groups,condition_product_groups.kuko_product_group,condition_products,condition_products.kuko_product,otc_product_attachments`
      axios
        .get(url)
        .then(response => {
          let newObj = response.data
          delete newObj.id

          newObj.user_id = this.user.id
          let clearObjects = ['condition_product_groups', 'condition_products','otc_product_attachments']
          clearObjects.forEach(o => {
            newObj[o].forEach(r => {
              delete r.id
              delete r.chargeback_id
            })
          })
          newObj.file_name = [...Array(30)].map(() => Math.random().toString(36)[2]).join('')

          let today = new Date();
          let month = (today.getMonth() + 1).toString().padStart(2, "0");
          let day = today.getDate().toString().padStart(2, "0");
          let date = today.getFullYear()+'-'+month+'-'+day;
          newObj.chargeback_date = date

          axios
            .get(`/api/chargebacks/new`)
            .then((response) => {
              let responseData = response.data
              axios
              .post(`/api/chargebacks/new`, newObj)
              .then((response) => {
                let responseData = response.data

                this.$router.push({
                  name: 'sandoz.chargebacks.detail',
                  params: { id: responseData.id }
                })
              })
            })
        })
    }
  }
}
</script>
